import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RoleFormModule } from '../form/role-form.module';
import { AddRoleRoutingModule } from './add-role-routing.module';
import { AddRoleComponent } from './add-role.component';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';

@NgModule({
  imports: [
    CommonModule,
    AddRoleRoutingModule,
    FormsModule,
    AppMaterialModule,
    RoleFormModule,
  ],
  declarations: [AddRoleComponent],
  exports: [AddRoleComponent],
  providers: [],
})
export class AddRoleModule {}
